var script_loaded = !1;

function loadJSscripts() {
    if (!script_loaded) {
        // Disconnect the observer if defined (not shown in provided snippet)
        // observer.disconnect();

        // Mark scripts as loaded
        script_loaded = !0;

        // Lazy load iframes
        document.querySelectorAll("iframe.lazy").forEach(t => {
            var datasrc = t.dataset.src;
            if (datasrc != null) {
                t.src = datasrc;
            }
        });

        // Lazy load scripts
        var t = document.getElementsByTagName("script");
        for (var i = 0; i < t.length; i++) {
            if (t[i].getAttribute("data-src") !== null) {
                t[i].setAttribute("src", t[i].getAttribute("data-src"));
                delete t[i].dataset.src;
            }

            if (t[i].getAttribute("type") == "text/lazyload") {
                var e = document.createElement("script");
                for (var a = 0; a < t[i].attributes.length; a++) {
                    var n = t[i].attributes[a];
                    e.setAttribute(n.name, n.value);
                }
                e.type = "text/javascript";
                e.innerHTML = t[i].innerHTML;
                t[i].parentNode.removeChild(t[i]);
                t[i].parentNode.insertBefore(e, t[i]);
            }
        }

        // Lazy load styles
        var r = document.getElementsByTagName("link");
        for (var i = 0; i < r.length; i++) {
            if (r[i].getAttribute("data-href") !== null) {
                r[i].setAttribute("href", r[i].getAttribute("data-href"));
                delete r[i].dataset.href;
            }
        }

        // Dispatch a custom event indicating lazy loading is complete
        document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
    }
}

// Define activity events that will trigger lazy loading
var activityEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"];

// Add event listeners for activity events
activityEvents.forEach(function(event) {
    window.addEventListener(event, loadJSscripts, !1);
});

// Add event listeners for the window load event
window.addEventListener ? window.addEventListener("load", function() {}, !1) :
window.attachEvent ? window.attachEvent("onload", function() {}) :
window.onload = function(event) {};
